import { render } from "./btn.vue?vue&type=template&id=6f6d941a&ts=true"
import script from "./btn.vue?vue&type=script&lang=ts"
export * from "./btn.vue?vue&type=script&lang=ts"

import "./btn.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/www/apps/mydr/mydr-welcome/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__